export default __webpack_public_path__ + "static/media/check.77a1cdc5.svg";